var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-user-list',{attrs:{"role":"distributor","users":_vm.users,"columns":[ 'name', 'email', 'role' ],"columnProps":{
    role: { class: 'role-cell'}
  }},on:{"userClick":_vm.onUserClick,"addUser":_vm.onAddUser,"removeUser":_vm.onRemoveUser}},[_c('ez-distributor-user-modal',{ref:"userModal",attrs:{"roles":_vm.roles,"distributorId":_vm.loggedUser.distributor.id,"userId":_vm.selectedUserId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }